import { Button } from '@consta/uikit/Button'
import { ModalBody, ModalFooter, ModalHeader } from '@core/components'
import { IconMapFetching } from '@core/icons'
import { usingMovingModal } from '@library/model'
import type { ProjectId } from 'common/types'
import { forwardRef } from 'react'

import { useMapFetching } from './hooks'
import { LeftMenu } from './LeftMenu'
import css from './MapFetching.css'
import { RightMenu } from './RightMenu'

type MapFetchingModalProps = {
  projectId: ProjectId
  closeModal: VoidFunction
  onClose?: VoidFunction
}

const MapFetching = forwardRef<HTMLDivElement, MapFetchingModalProps>(function MapFetching(
  { closeModal, onClose, projectId },
  ref,
) {
  const {
    chosenMap,
    chosenMarker,
    newMapName,
    statistics,
    isCalculating,
    isButtonDisabled,
    onMapChange,
    clearModalData,
    onMarkerChange,
    onNameChange,
    onCalculate,
  } = useMapFetching(projectId)

  const handleClose = () => {
    closeModal()
    clearModalData()
    onClose?.()
  }

  return (
    <>
      <ModalHeader
        ref={ref}
        title="Подсадка карт"
        icon={IconMapFetching}
        onCloseClick={handleClose}
      />
      <ModalBody className={css.container}>
        <LeftMenu
          chosenMap={chosenMap}
          chosenMarker={chosenMarker}
          onMapChange={onMapChange}
          onMarkerChange={onMarkerChange}
        />
        <RightMenu statisticsProps={statistics} name={newMapName} onNameChange={onNameChange} />
      </ModalBody>
      <ModalFooter className={css.footer}>
        <Button
          size="xs"
          label="Рассчитать"
          disabled={isButtonDisabled}
          loading={isCalculating}
          onClick={onCalculate}
        />
      </ModalFooter>
    </>
  )
})

export const MapFetchingModal = usingMovingModal(MapFetching)
